// import messaging from '@react-native-firebase/messaging'
// import * as Linking from 'expo-linking'
import { inject, observer } from 'mobx-react'
import { Box, useToast } from 'native-base'
import React from 'react'
import Login from '../../components/Login'
import LocalizationContext from '../../context/LocalizationContext'

function LoginScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { authStore, navigation } = props
    const toast = useToast()
    const handleOnSubmitError = async (errors) => {
        const _errorMessages = []
        if (errors && errors.length) {
            for (const errorCode of errors) {
                _errorMessages.push(t(errorCode.toString()))
            }
            return toast.show({
                placement: 'top',
                render: () => {
                    return (
                        <Box bg="red.500" px={4} py={3} rounded="md" mb={5} _text={{ color: 'white' }}>
                            {_errorMessages.join('\r\n')}
                        </Box>
                    )
                },
            })
        }
    }


    const handleOnSubmitPress = async (values) => {
        const { email, password } = values
        try {
            await authStore.login(email, password)
            return navigation.replace('Main')
        }
        catch (e) {
            console.log(e)
            handleOnSubmitError(e)
        }
    }

    return (
        <Login
            t={t}
            onSubmitPress={(values) => handleOnSubmitPress(values)}
        />
    )
}

export default inject('authStore')(observer(LoginScreen))